function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  "data-name": "<Pfad>",
  cx: 80.1,
  cy: 80.46,
  r: 36
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.1 52.1a16 16 0 0115.65-16h15.64a11.7 11.7 0 008.94-4.12L60.94 8.1a14.42 14.42 0 0110.22-4h17.88c3.54 0 7.67 1.23 10.18 3.72l16.64 24.28a14.24 14.24 0 009.75 4h15.3c8.36 0 15.19 7.31 15.19 15.66v73.15a15.23 15.23 0 01-15.19 15.19H19.3a15.24 15.24 0 01-15.2-15.2V52.1z"
});

var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160.2 144.2",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgCamera;